module.exports = __webpack_public_path__ + "img/1Itm7Yrl3Y_KeVdhxgXklkcPjZQI4GJta.796e0a01.png";